import { Link } from "react-router-dom";
import PageHeader from "../shared/PageHeader";

export default function SecurityPolicy() {
  return (
    <div className="container page-navbar-space">
      <PageHeader>Security Policy</PageHeader>
      <div
        className="mt-4"
        style={{ maxWidth: "900px", color: "#444", lineHeight: "1.7" }}
      >
        <p className="size-16 fw-normal">
          Ownfood applies reasonable technical and organizational safeguards to
          protect user and partner information from unauthorized access, misuse,
          and disclosure.
        </p>
        <p className="size-16 fw-normal">
          Security controls may include access restriction, secure data
          transmission, monitoring, and ongoing maintenance practices.
        </p>
        <p className="size-16 fw-normal mb-4">
          To report a security concern, please contact our team via
          <Link to="/contact-us" className="text-decoration-none">
            {" "}
            Contact Us{" "}
          </Link>
          .
        </p>
      </div>
    </div>
  );
}
